import React, {useState} from 'react';
import {Button} from '@material-ui/core';
import CheckIcon from 'components/CheckIcon/CheckIcon';
import {Route} from 'react-router-dom';
import {IFdUser, ISupplierUserProfile} from 'constants/interfaces';
import {FdUserForm} from 'components/applications/FdUserForm';
import {
  reduxToggleSidePanel,
  reduxSetSidePanelEditState,
} from 'appredux/actions';

const AddOrUpdateFdUser = (props: {
  user: ISupplierUserProfile;
  fdUser?: IFdUser;
}) => {
  const [fdUser, setFdUser] = useState(props.fdUser);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSuccessfullyCreatedUser, setHasSuccessfullyCreatedUser] =
    useState(false);

  const isAdding = !props.fdUser;

  const handleSubmit = (user: Partial<IFdUser>) => {
    if (!canWrite) return;
    setIsLoading(true);
    new Promise((resolve) => setTimeout(resolve, 1000))
      .then(() => {
        setHasSuccessfullyCreatedUser(true);
        reduxSetSidePanelEditState('saved');
      })
      .catch((err) => {
        alert('Failed to save user at the moment. Please try again later');
        console.error('Failed to save user', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleCancel = () => {
    reduxToggleSidePanel(false, null);
  };

  const canWrite = true;

  if (hasSuccessfullyCreatedUser) {
    return (
      <Route
        render={() => (
          <div className="side-panel-success-container">
            <div className="mid-section">
              <div className="success-gif">
                <CheckIcon />
              </div>
              <div className="success-msg">
                {isAdding
                  ? 'User added successfully'
                  : 'User updated successfully'}
              </div>
            </div>
            <div className="btn-container">
              {isAdding && (
                <Button
                  className="primary-btn alt-button"
                  type="submit"
                  variant="outlined"
                  disabled={isLoading}
                  onClick={() => {
                    setFdUser(undefined);
                    setHasSuccessfullyCreatedUser(false);
                  }}
                >
                  Add another user
                </Button>
              )}
              <Button
                className="primary-btn"
                type="submit"
                variant="outlined"
                color="primary"
                disabled={isLoading}
                onClick={() => {
                  reduxToggleSidePanel(false, null);
                }}
              >
                View Users
              </Button>
            </div>
          </div>
        )}
      />
    );
  }

  return (
    <FdUserForm
      user={fdUser}
      isLoading={isLoading}
      submitButtonTitle={isAdding ? 'Add' : 'Update'}
      onSubmit={handleSubmit}
      cancelButtonTitle={'Cancel'}
      onCancel={handleCancel}
      readonly={!canWrite}
    />
  );
};

export default AddOrUpdateFdUser;
